import type { ReactNode, RefObject } from 'react'
import { RegisterShowcase } from './register-showcase'

export type RegisterLayoutProps = {
  children: ReactNode
  scrollRef?: RefObject<HTMLDivElement | null>
}

export function RegisterLayout({ children, scrollRef }: RegisterLayoutProps) {
  return (
    <div
      data-testid="register-layout"
      className="flex min-h-screen flex-col bg-background md:h-screen md:flex-row md:overflow-hidden"
    >
      <div
        ref={scrollRef}
        className="order-2 flex w-full flex-col md:order-1 md:w-[70%] md:overflow-y-auto"
      >
        {children}
      </div>
      <RegisterShowcase />
    </div>
  )
}
